<template>
  <div data-testid="today-position">
    <template v-if="isLoading">
      <SkeletonLoader class="today-position__loader">
        <div
          v-for="index in 4"
          :key="index"
          class="today-position__row--loader"
        />
      </SkeletonLoader>
    </template>
    <template v-else>
      <Row left-title="Preço" :right-title="priceFormatted" />
      <Row
        v-if="position.avgPrice && position.avgPrice.value > 0"
        left-title="Preço médio"
        :right-title="position.avgPrice.formatted"
      />
      <Row left-title="Quantidade" :right-title="String(position.quantity)" />
      <Row
        v-if="position.btc"
        left-title="Quantidade em custódia remunerada"
        :right-title="position.btc"
      />
      <Row
        left-title="Saldo total"
        :right-title="position.currentValue.formatted"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { TradeInstrumentPositionPrice } from '@/modules/trade/types/instrument';
import { Row, SkeletonLoader } from '@warrenbrasil/nebraska-web';

interface Props {
  position: TradeInstrumentPositionPrice;
  isLoading: boolean;
}
const props = defineProps<Props>();

const priceFormatted = computed(() => props.position.price?.formatted || '-');
</script>

<style lang="less" scoped>
.today-position {
  &__loader {
    display: flex;
    flex-direction: column;
  }

  &__row {
    &--loader {
      height: 29px;
      width: 100%;
      border-radius: @size-radius-x100;
      margin: @size-spacing-x350 0;
    }
  }
}
</style>
